module.exports = __webpack_public_path__ + "static/media/autokar (12).ecaf21ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (12).jpg
// module id = 842
// module chunks = 0